var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStmLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_509)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0865 9.93882C16.415 8.54826 13.1068 8.5059 10.3019 10.115V10.1154C8.85088 10.948 7.71763 12.1177 6.94439 13.4674C6.5265 14.1965 5.76116 15.5193 4.8659 17.061C7.53737 18.4515 10.8454 18.4938 13.6503 16.8848C15.1013 16.0522 16.2346 14.8825 17.0078 13.5327C17.4257 12.8036 18.1911 11.4807 19.0865 9.93882ZM19.0865 9.93886C20.6248 7.28874 22.5457 3.99076 23.7404 1.93987C24.2421 1.07892 23.6164 0.00175971 22.615 0.00292631C18.8431 0.00798158 11.4441 0.0153701 9.14985 0.000204245C7.52041 -0.010684 5.86554 0.41357 4.36406 1.32041C0.200071 3.83599 -1.22862 9.23424 1.14901 13.4612C2.04625 15.0563 3.35394 16.2742 4.86549 17.0612C3.32726 19.7113 1.40639 23.0091 0.211755 25.0599C-0.289912 25.9209 0.335802 26.998 1.33718 26.9969C5.10907 26.9918 12.5081 26.9844 14.8023 26.9996C16.4318 27.0105 18.0867 26.5862 19.5881 25.6794C23.7521 23.1638 25.1808 17.7659 22.8036 13.539H22.8032C21.9059 11.9438 20.5981 10.7259 19.0865 9.93886Z",
    fill: "#F2F4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 27,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStmLogoIcon);
export default __webpack_public_path__ + "static/media/stm_logo_icon.4270a3ee98f25df257b98164cd17e022.svg";
export { ForwardRef as ReactComponent };